<script>
  import CuratedByGridItem from './CuratedByGridItem.svelte';
  import CuratedByAnalytics from './CuratedByAnalytics.svelte';

  export let isDynamic;
  export let recentLinks;
  export let topLinks;
  export let profileImageUrl;
  export let handle;
  export let bioLine1;
  export let bioLine2;
  export let previewMode = false;

  let scrollItemIdx = 0;

  function scrollCarousel(newIdx) {
    scrollItemIdx = newIdx;
    const scrollItem = document.getElementById(`scroll-item-${newIdx}`);
    scrollItem.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'start',
    });
  }
</script>

<svelte:head>
  <title>{handle}'s CuratedBy Page</title>
</svelte:head>
<CuratedByAnalytics {isDynamic} />
<img
  class="absolute -top-[60px] h-[278px] w-full max-w-[100vw] max-w-[unset] overflow-visible object-cover sm:-top-[50px] lg:-top-[90px]"
  src="/images/bg-vector.svg"
/>
<div class="mx-auto min-h-[100vh] w-full max-w-xl md:max-w-3xl">
  <div
    class="mb-10 flex w-full flex-row items-center justify-between gap-2 px-3 py-8 text-white sm:py-4 lg:mb-12"
  >
    <div class="grow-1 z-10 w-full shrink-0 basis-0">
      {#if handle}
        {#if handle.length > 12 && previewMode}
          <h1 class="w-full min-w-[11ch] text-nowrap text-sm font-bold">
            {handle}
          </h1>
        {:else if handle.length > 7 && previewMode}
          <h1 class="w-full min-w-[11ch] text-nowrap text-lg font-bold">
            {handle}
          </h1>
        {:else}
          <h1 class="w-full text-wrap text-2xl font-bold">{handle}</h1>
        {/if}
      {/if}
      {#if bioLine1 || bioLine2}
        <article class="max-w-[20ch] text-nowrap text-sm font-semibold">
          <p>{bioLine1}</p>
          <p>{bioLine2}</p>
        </article>
      {/if}
    </div>
    {#if profileImageUrl}
      <div class="grow-1 w-full shrink-0 basis-0">
        <div class="relative w-48">
          <div class="absolute right-0 top-0 flex justify-end">
            <button
              on:click={() =>
                navigator.clipboard.writeText(window.location.toString())}
              disabled={previewMode}
            >
              <svg
                width="19"
                height="23"
                viewBox="0 0 19 23"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.83331 11.4998V19.1665C1.83331 19.6748 2.03525 20.1623 2.39469 20.5218C2.75414 20.8812 3.24165 21.0832 3.74998 21.0832H15.25C15.7583 21.0832 16.2458 20.8812 16.6053 20.5218C16.9647 20.1623 17.1666 19.6748 17.1666 19.1665V11.4998M13.3333 5.74984L9.49998 1.9165M9.49998 1.9165L5.66665 5.74984M9.49998 1.9165V14.3748"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
          <img
            class={`max-xs:relative max-xs:top-10 xs:h-40 xs:w-40 h-36 w-36 justify-self-center rounded-full border-[.475rem] border-white object-cover sm:h-48 sm:w-48`}
            src={profileImageUrl}
          />
        </div>
      </div>
    {/if}
  </div>
  {#if (!recentLinks || !recentLinks.length) && (!topLinks || !topLinks.length)}
    <div class="flex h-24 w-full items-center justify-center">
      Start creating now 💡
    </div>
  {/if}
  {#if recentLinks && recentLinks.length}
    <div class="mb-4 px-3 lg:mt-12">
      <div class="flex flex-row items-baseline gap-2">
        <h2 class="mb-2 text-2xl font-bold">Recent Posts</h2>
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_5244_6474)">
            <circle cx="12.5" cy="12.5" r="11.5" fill="#181818" />
            <path
              d="M0 12.4509C0.0623002 5.61647 5.45303 0.0341874 12.4436 0.000156206C19.3495 -0.033875 24.9906 5.49678 25 12.5213C25.0094 19.3967 19.4706 25.0166 12.4753 25.0002C5.74925 24.9849 0.0611247 19.6279 0 12.4509ZM11.6231 21.9902C15.1519 21.881 18.1129 20.4928 20.2734 17.6084C22.0836 15.191 22.7396 12.4427 22.2729 9.45026C21.932 7.26522 20.9987 5.41698 19.1885 4.05808C16.7352 2.2157 13.9999 1.41069 10.9519 1.86483C7.59709 2.36356 5.00987 4.10033 3.27722 6.99532C1.61745 9.77062 1.29655 12.7571 2.29335 15.8434C2.5308 16.578 2.81761 17.3549 3.29133 17.9428C5.40248 20.5644 8.18366 21.901 11.6231 21.9902Z"
              fill="#181818"
            />
            <path
              d="M13.3748 11.6346C13.5182 11.6346 13.6322 11.6346 13.7462 11.6346C15.2614 11.6346 16.7754 11.6346 18.2906 11.6346C18.407 11.6346 18.5269 11.6311 18.6409 11.6545C19.0617 11.7402 19.3627 12.1298 19.3403 12.5441C19.3168 12.9794 18.9748 13.3315 18.5351 13.3714C18.4575 13.3784 18.3788 13.3761 18.3012 13.3761C16.4252 13.3761 14.5491 13.3761 12.6719 13.3761C11.9936 13.3761 11.6574 13.0451 11.6574 12.3751C11.6562 10.0433 11.6574 7.71163 11.6562 5.38108C11.6562 4.995 11.7903 4.69459 12.157 4.53147C12.4814 4.38713 12.7871 4.43524 13.0668 4.64765C13.3278 4.84479 13.376 5.12643 13.376 5.43036C13.3736 7.37131 13.376 9.31344 13.376 11.2544C13.376 11.3694 13.376 11.4832 13.376 11.6334L13.3748 11.6346Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5244_6474">
              <rect width="25" height="25" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="relative">
        {#if scrollItemIdx > 0}
          <button
            class="absolute left-2 top-1/2 z-20 h-8 w-8 -translate-y-1/2 rotate-180"
            on:click={() => scrollCarousel(scrollItemIdx - 1)}
          >
            <svg
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_4946_1125)">
                <circle cx="22" cy="18" r="18" fill="#181818" />
                <circle cx="22" cy="18" r="17.5" stroke="white" />
              </g>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.8424 14.4748C22.3716 14.0067 22.3716 13.245 22.8424 12.7769C23.3094 12.3125 24.0637 12.3125 24.5307 12.7769L29.3356 17.5544C29.5609 17.7782 29.6875 18.0819 29.6875 18.3986C29.6875 18.7153 29.5609 19.019 29.3356 19.2428L24.5307 24.0203C24.0637 24.4846 23.3094 24.4846 22.8424 24.0203C22.3716 23.5522 22.3716 22.7904 22.8424 22.3223L25.5886 19.5918H16.4797C15.8208 19.5918 15.2866 19.0576 15.2866 18.3986C15.2866 17.7396 15.8208 17.2054 16.4797 17.2054H25.5886L22.8424 14.4748Z"
                fill="white"
              />
              <defs>
                <filter
                  id="filter0_d_4946_1125"
                  x="0"
                  y="0"
                  width="44"
                  height="44"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4946_1125"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4946_1125"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>
        {/if}
        <div
          id="scroll-handle"
          class="no-scrollbar relative flex w-full flex-row gap-2 overflow-x-scroll"
        >
          {#each recentLinks as recentLink, idx}
            <div class="w-[112px] shrink-0">
              <CuratedByGridItem
                {previewMode}
                index={idx}
                shortlink={recentLink.shortlink}
                imageUrl={recentLink.image_url}
                isList={recentLink.is_list}
              />
            </div>
          {/each}
        </div>
        {#if scrollItemIdx < recentLinks.length}
          <button
            class="absolute right-2 top-1/2 z-20 h-8 w-8 -translate-y-1/2"
            on:click={() => scrollCarousel(scrollItemIdx + 1)}
          >
            <svg
              class=""
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g filter="url(#filter0_d_4946_1125)">
                <circle cx="22" cy="18" r="18" fill="#181818" />
                <circle cx="22" cy="18" r="17.5" stroke="white" />
              </g>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.8424 14.4748C22.3716 14.0067 22.3716 13.245 22.8424 12.7769C23.3094 12.3125 24.0637 12.3125 24.5307 12.7769L29.3356 17.5544C29.5609 17.7782 29.6875 18.0819 29.6875 18.3986C29.6875 18.7153 29.5609 19.019 29.3356 19.2428L24.5307 24.0203C24.0637 24.4846 23.3094 24.4846 22.8424 24.0203C22.3716 23.5522 22.3716 22.7904 22.8424 22.3223L25.5886 19.5918H16.4797C15.8208 19.5918 15.2866 19.0576 15.2866 18.3986C15.2866 17.7396 15.8208 17.2054 16.4797 17.2054H25.5886L22.8424 14.4748Z"
                fill="white"
              />
              <defs>
                <filter
                  id="filter0_d_4946_1125"
                  x="0"
                  y="0"
                  width="44"
                  height="44"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                  />
                  <feOffset dy="4" />
                  <feGaussianBlur stdDeviation="2" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                  />
                  <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_4946_1125"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_4946_1125"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>
        {/if}
      </div>
    </div>
  {/if}

  {#if recentLinks && recentLinks.length && topLinks && topLinks.length}
    <div class="my-4 hidden h-8 w-full max-sm:block"></div>
  {/if}

  {#if topLinks && topLinks.length}
    <div class="flex justify-between px-3">
      <div class="flex gap-2">
        <div>
          <h2 class="text-2xl font-bold">Trending Posts</h2>
          <p class="text-[.675rem] font-normal text-gray-600">
            Ordered by popularity
          </p>
        </div>
        <svg
          width="21"
          height="27"
          viewBox="0 0 21 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_4946_1443)">
            <path
              d="M10.4663 27C5.25696 26.9941 0.819921 23.179 0.115156 18.033C-0.36726 14.514 0.688894 11.4276 2.97392 8.73412C3.03745 8.65908 3.09502 8.57022 3.17642 8.52085C3.32134 8.43199 3.54369 8.26612 3.62111 8.31351C3.75412 8.39645 3.8653 8.61366 3.87522 8.77954C3.92883 9.72344 4.10154 10.6357 4.51051 11.4908C5.01079 12.5374 5.75526 13.3174 6.89082 13.7103C8.56439 14.2909 11.4311 12.96 11.3358 10.3257C11.2921 9.13696 11.044 7.95411 10.8554 6.77325C10.6191 5.29815 10.2935 3.82305 10.641 2.33216C10.7958 1.67064 11.0837 1.03676 11.3497 0.40683C11.4212 0.238981 11.6336 0.132348 11.7805 -0.00390625C11.8857 0.181715 12.0326 0.355488 12.0922 0.554932C12.3523 1.44947 12.523 2.37363 12.8426 3.24644C13.4084 4.79263 14.5102 5.97547 15.6597 7.11882C16.7198 8.1733 17.8315 9.1883 18.7825 10.3336C23.0329 15.458 20.8908 23.3469 14.7822 26.0858C13.3965 26.7078 12.0167 26.9961 10.4663 26.9941V27ZM6.91465 19.9563C7.7147 21.1372 8.61005 22.0278 9.77738 22.6103C11.5125 23.4732 13.1464 23.1731 14.6373 22.0376C16.0091 20.993 16.3903 19.5732 16.0667 17.9184C15.7649 16.3722 15.0363 15.0294 14.1429 13.7577C14.1132 13.7143 14.0496 13.6926 13.9305 13.6136C13.9305 13.8486 13.9365 14.0085 13.9305 14.1685C13.867 15.5429 13.6049 16.8659 12.9081 18.0744C11.6733 20.213 9.66422 20.9358 7.35339 20.0748C7.25412 20.0373 7.14891 20.0195 6.91663 19.9563H6.91465Z"
              fill="#0B1014"
            />
          </g>
          <defs>
            <clipPath id="clip0_4946_1443">
              <rect width="21" height="27" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="self-end">
        <p class="text-[.675rem] font-normal text-gray-600">
          {topLinks.length} Posts
        </p>
      </div>
    </div>
    <div class="px-3">
      <div
        class="my-4 grid grid-cols-3 gap-2 sm:grid-cols-4 sm:gap-2 md:grid-cols-5"
      >
        {#each topLinks as topLink}
          <CuratedByGridItem
            {previewMode}
            shortlink={topLink.shortlink}
            imageUrl={topLink.image_url}
            isList={topLink.is_list}
          ></CuratedByGridItem>
        {/each}
      </div>
    </div>
  {/if}
</div>

<footer class="relative z-10 h-[408px]">
  <div
    class="absolute bottom-4 left-1/2 z-10 flex w-full -translate-x-1/2 flex-col items-center px-3"
  >
    <img src="/images/curatedby-logo.png" class="z-10 h-24 self-center" />

    <p
      class="mt-2 w-full max-w-[60ch] border-t border-white px-3 pt-1 text-center text-xs text-gray-300"
    >
      Disclaimer: Contributors independently recommend products and may earn
      commissions on purchases.
    </p>
  </div>
  <img
    src="/images/bg-footer-vector.svg"
    class="absolute h-[408px] w-full max-w-[unset] overflow-visible object-cover"
  />
</footer>
